/** @format */

import {useState, useEffect} from 'react';

import {Modal} from '@mui/material';

import {BookDemoForm} from './components/BookDemoForm';
import {SuccessState} from './components/SuccessState';
import {ModalPaper} from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BookDemoModal = ({isOpen, onClose}: Props) => {
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsSuccess(false);
    }
  }, [isOpen]);

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  const handleClose = () => {
    setIsSuccess(false);
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalPaper isSuccess={isSuccess}>
        {isSuccess ? (
          <SuccessState onClose={handleClose} />
        ) : (
          <BookDemoForm onSuccess={handleSuccess} onClose={handleClose} />
        )}
      </ModalPaper>
    </Modal>
  );
};

export {BookDemoModal};
